import './templates/T1/index.scss';

import React, { FC } from 'react';

import { CompositorProvider, CompositorProviderProps } from './components/CompositorProvider';
import { CoreCompositor, CoreCompositorProps } from './components/CoreCompositor';

export type JFormCompositorProps = CoreCompositorProps & {
    providerProps?: CompositorProviderProps
}

export const JFormCompositor: FC<JFormCompositorProps> = ({ providerProps, ...formProps }) => {
    if (providerProps && Object.keys(providerProps).length > 0) return (
        <span className="form-style-wrapper">
            <CompositorProvider {...providerProps}>
                <CoreCompositor {...formProps} />
            </CompositorProvider>
        </span>
    )
    return (
        <span className="form-style-wrapper">
            <CoreCompositor {...formProps} />
        </span>
    )
}
